export const domains = {
  // Local
  LOCAL: 'http://localhost:3000',
  // Development
  DEV_AXA: 'https://dev-axa.sttok.com',
  DEV_STTOK: 'https://development.sttok.com',
  // Production
  AXA: 'https://accionistasagrupacio.axa.es',
  ASG: 'https://accionistas.axa.es',
  STTOK: 'https://app.sttok.com',
};

export const isProductionEnv = !![
  domains.AXA,
  domains.ASG,
  domains.STTOK,
].includes(process.env.REACT_APP_DOMAIN || '');

export const isDevelopmentEnv = !![domains.DEV_AXA, domains.DEV_STTOK].includes(
  process.env.REACT_APP_DOMAIN || ''
);

export const isLocalEnv = !![domains.LOCAL].includes(
  process.env.REACT_APP_DOMAIN || ''
);
